import { render } from "./checkPosition.vue?vue&type=template&id=35c42ac0&scoped=true&ts=true"
import script from "./checkPosition.vue?vue&type=script&lang=ts"
export * from "./checkPosition.vue?vue&type=script&lang=ts"

import "./checkPosition.vue?vue&type=style&index=0&id=35c42ac0&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c42ac0"]])

export default __exports__